var _path, _rect, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _rect4, _g, _rect5, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78 388H396V406H78V388Z",
    fill: "url(#paint0_linear_106_1035)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M297 296H396V314H297V296Z",
    fill: "url(#paint1_linear_106_1035)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M297 213H396V231H297V213Z",
    fill: "url(#paint2_linear_106_1035)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M297 254H396V272H297V254Z",
    fill: "url(#paint3_linear_106_1035)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78 443H396V461H78V443Z",
    fill: "url(#paint4_linear_106_1035)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#0070BA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_1035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.632 64.7386H94.8821C94.5185 62.6477 93.848 60.7955 92.8707 59.1818C91.8935 57.5455 90.6776 56.1591 89.223 55.0227C87.7685 53.8864 86.1094 53.0341 84.2457 52.4659C82.4048 51.875 80.4162 51.5795 78.2798 51.5795C74.4844 51.5795 71.1207 52.5341 68.1889 54.4432C65.2571 56.3295 62.9616 59.1023 61.3026 62.7614C59.6435 66.3977 58.8139 70.8409 58.8139 76.0909C58.8139 81.4318 59.6435 85.9318 61.3026 89.5909C62.9844 93.2273 65.2798 95.9773 68.1889 97.8409C71.1207 99.6818 74.473 100.602 78.2457 100.602C80.3366 100.602 82.2912 100.33 84.1094 99.7841C85.9503 99.2159 87.598 98.3864 89.0526 97.2955C90.5298 96.2045 91.7685 94.8636 92.7685 93.2727C93.7912 91.6818 94.4957 89.8636 94.8821 87.8182L107.632 87.8864C107.155 91.2045 106.121 94.3182 104.53 97.2273C102.962 100.136 100.905 102.705 98.3594 104.932C95.8139 107.136 92.8367 108.864 89.4276 110.114C86.0185 111.341 82.2344 111.955 78.0753 111.955C71.9389 111.955 66.4616 110.534 61.6435 107.693C56.8253 104.852 53.0298 100.75 50.2571 95.3864C47.4844 90.0227 46.098 83.5909 46.098 76.0909C46.098 68.5682 47.4957 62.1364 50.2912 56.7955C53.0866 51.4318 56.8935 47.3295 61.7116 44.4886C66.5298 41.6477 71.9844 40.2273 78.0753 40.2273C81.9616 40.2273 85.5753 40.7727 88.9162 41.8636C92.2571 42.9545 95.2344 44.5568 97.848 46.6705C100.462 48.7614 102.609 51.3295 104.291 54.375C105.996 57.3977 107.109 60.8523 107.632 64.7386ZM157.158 60.375C156.839 57.3977 155.499 55.0795 153.135 53.4205C150.794 51.7614 147.749 50.9318 143.999 50.9318C141.362 50.9318 139.101 51.3295 137.214 52.125C135.328 52.9205 133.885 54 132.885 55.3636C131.885 56.7273 131.374 58.2841 131.351 60.0341C131.351 61.4886 131.68 62.75 132.339 63.8182C133.021 64.8864 133.942 65.7955 135.101 66.5455C136.26 67.2727 137.544 67.8864 138.953 68.3864C140.362 68.8864 141.783 69.3068 143.214 69.6477L149.76 71.2841C152.396 71.8977 154.93 72.7273 157.362 73.7727C159.817 74.8182 162.01 76.1364 163.942 77.7273C165.896 79.3182 167.442 81.2386 168.578 83.4886C169.714 85.7386 170.283 88.375 170.283 91.3977C170.283 95.4886 169.237 99.0909 167.146 102.205C165.055 105.295 162.033 107.716 158.078 109.466C154.146 111.193 149.385 112.057 143.794 112.057C138.362 112.057 133.646 111.216 129.646 109.534C125.669 107.852 122.555 105.398 120.305 102.17C118.078 98.9432 116.874 95.0114 116.692 90.375H129.135C129.317 92.8068 130.067 94.8295 131.385 96.4432C132.703 98.0568 134.419 99.2614 136.533 100.057C138.669 100.852 141.055 101.25 143.692 101.25C146.442 101.25 148.851 100.841 150.919 100.023C153.01 99.1818 154.646 98.0227 155.828 96.5455C157.01 95.0455 157.612 93.2955 157.635 91.2955C157.612 89.4773 157.078 87.9773 156.033 86.7955C154.987 85.5909 153.521 84.5909 151.635 83.7955C149.771 82.9773 147.589 82.25 145.089 81.6136L137.146 79.5682C131.396 78.0909 126.851 75.8523 123.51 72.8523C120.192 69.8295 118.533 65.8182 118.533 60.8182C118.533 56.7045 119.646 53.1023 121.874 50.0114C124.124 46.9205 127.18 44.5227 131.044 42.8182C134.908 41.0909 139.283 40.2273 144.169 40.2273C149.124 40.2273 153.464 41.0909 157.192 42.8182C160.942 44.5227 163.885 46.8977 166.021 49.9432C168.158 52.9659 169.26 56.4432 169.328 60.375H157.158ZM219.501 60.375C219.183 57.3977 217.842 55.0795 215.479 53.4205C213.138 51.7614 210.092 50.9318 206.342 50.9318C203.706 50.9318 201.445 51.3295 199.558 52.125C197.672 52.9205 196.229 54 195.229 55.3636C194.229 56.7273 193.717 58.2841 193.695 60.0341C193.695 61.4886 194.024 62.75 194.683 63.8182C195.365 64.8864 196.286 65.7955 197.445 66.5455C198.604 67.2727 199.888 67.8864 201.297 68.3864C202.706 68.8864 204.126 69.3068 205.558 69.6477L212.104 71.2841C214.74 71.8977 217.274 72.7273 219.706 73.7727C222.161 74.8182 224.354 76.1364 226.286 77.7273C228.24 79.3182 229.786 81.2386 230.922 83.4886C232.058 85.7386 232.626 88.375 232.626 91.3977C232.626 95.4886 231.581 99.0909 229.49 102.205C227.399 105.295 224.376 107.716 220.422 109.466C216.49 111.193 211.729 112.057 206.138 112.057C200.706 112.057 195.99 111.216 191.99 109.534C188.013 107.852 184.899 105.398 182.649 102.17C180.422 98.9432 179.217 95.0114 179.036 90.375H191.479C191.661 92.8068 192.411 94.8295 193.729 96.4432C195.047 98.0568 196.763 99.2614 198.876 100.057C201.013 100.852 203.399 101.25 206.036 101.25C208.786 101.25 211.195 100.841 213.263 100.023C215.354 99.1818 216.99 98.0227 218.172 96.5455C219.354 95.0455 219.956 93.2955 219.979 91.2955C219.956 89.4773 219.422 87.9773 218.376 86.7955C217.331 85.5909 215.865 84.5909 213.979 83.7955C212.115 82.9773 209.933 82.25 207.433 81.6136L199.49 79.5682C193.74 78.0909 189.195 75.8523 185.854 72.8523C182.536 69.8295 180.876 65.8182 180.876 60.8182C180.876 56.7045 181.99 53.1023 184.217 50.0114C186.467 46.9205 189.524 44.5227 193.388 42.8182C197.251 41.0909 201.626 40.2273 206.513 40.2273C211.467 40.2273 215.808 41.0909 219.536 42.8182C223.286 44.5227 226.229 46.8977 228.365 49.9432C230.501 52.9659 231.604 56.4432 231.672 60.375H219.501Z",
    fill: "#FAFAFD"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 171,
    width: 180,
    height: 180,
    rx: 32,
    fill: "#0070BA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.267 263.091V253.955C109.509 253.955 113.146 252.909 115.176 250.818C117.206 248.727 118.222 245.348 118.222 240.682V230.636C118.222 225.03 118.994 220.545 120.54 217.182C122.116 213.788 124.297 211.227 127.085 209.5C129.903 207.773 133.237 206.621 137.085 206.045C140.934 205.47 145.146 205.182 149.722 205.182V219.636C146.146 219.636 143.419 220.106 141.54 221.045C139.691 221.955 138.434 223.379 137.767 225.318C137.1 227.227 136.767 229.652 136.767 232.591V245.864C136.767 248.167 136.343 250.364 135.494 252.455C134.646 254.515 133.07 256.348 130.767 257.955C128.464 259.53 125.176 260.788 120.903 261.727C116.631 262.636 111.085 263.091 104.267 263.091ZM149.722 320.227C145.146 320.227 140.934 319.939 137.085 319.364C133.237 318.788 129.903 317.636 127.085 315.909C124.297 314.182 122.116 311.621 120.54 308.227C118.994 304.864 118.222 300.379 118.222 294.773V284.682C118.222 280.015 117.206 276.636 115.176 274.545C113.146 272.455 109.509 271.409 104.267 271.409V262.273C111.085 262.273 116.631 262.742 120.903 263.682C125.176 264.591 128.464 265.848 130.767 267.455C133.07 269.03 134.646 270.864 135.494 272.955C136.343 275.015 136.767 277.212 136.767 279.545V292.818C136.767 295.727 137.1 298.136 137.767 300.045C138.434 301.985 139.691 303.409 141.54 304.318C143.419 305.258 146.146 305.727 149.722 305.727V320.227ZM104.267 271.409V253.955H120.585V271.409H104.267ZM230.722 262.273V271.409C225.509 271.409 221.873 272.455 219.812 274.545C217.782 276.636 216.767 280.015 216.767 284.682V294.773C216.767 300.379 215.979 304.864 214.403 308.227C212.858 311.621 210.676 314.182 207.858 315.909C205.07 317.636 201.752 318.788 197.903 319.364C194.085 319.939 189.873 320.227 185.267 320.227V305.727C188.843 305.727 191.555 305.258 193.403 304.318C195.282 303.409 196.555 301.985 197.222 300.045C197.888 298.136 198.222 295.727 198.222 292.818V279.545C198.222 277.212 198.646 275.015 199.494 272.955C200.343 270.864 201.919 269.03 204.222 267.455C206.525 265.848 209.813 264.591 214.085 263.682C218.358 262.742 223.903 262.273 230.722 262.273ZM185.267 205.182C189.873 205.182 194.085 205.47 197.903 206.045C201.752 206.621 205.07 207.773 207.858 209.5C210.676 211.227 212.858 213.788 214.403 217.182C215.979 220.545 216.767 225.03 216.767 230.636V240.682C216.767 245.348 217.782 248.727 219.812 250.818C221.873 252.909 225.509 253.955 230.722 253.955V263.091C223.903 263.091 218.358 262.636 214.085 261.727C209.813 260.788 206.525 259.53 204.222 257.955C201.919 256.348 200.343 254.515 199.494 252.455C198.646 250.364 198.222 248.167 198.222 245.864V232.591C198.222 229.652 197.888 227.227 197.222 225.318C196.555 223.379 195.282 221.955 193.403 221.045C191.555 220.106 188.843 219.636 185.267 219.636V205.182ZM230.722 253.955V271.409H214.403V253.955H230.722Z",
    fill: "#FAFAFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_1035",
    x: 34.0977,
    y: 40.2266,
    width: 202.527,
    height: 87.832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_1035"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_1035",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_1035",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29A8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0070BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_1035",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29A8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0070BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_1035",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29A8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0070BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_1035",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29A8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0070BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_106_1035",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29A8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0070BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.445541c5f4c85b223a5ee679640fef47.svg";
export { ForwardRef as ReactComponent };